import { jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from "react";
import { createTheme, ThemeProvider as ThemeProvider$1 } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { AchieveTheme } from "../../AchieveTheme.js";
const AscendThemeProvider = ({
  children,
  theme = AchieveTheme,
  customThemes = []
}) => {
  const muiTheme = useMemo(() => createTheme(theme, ...customThemes), [
    theme.name,
    theme == null ? void 0 : theme.useVanillaMui,
    ...customThemes.map((theme2) => theme2.name),
    // support dynamic theme
    ...customThemes.map((theme2) => theme2 == null ? void 0 : theme2.useVanillaMui)
    // support ejecting Achieve styles
  ]);
  return /* @__PURE__ */ jsx(ThemeProvider, { theme: muiTheme, children: /* @__PURE__ */ jsx(ThemeProvider$1, { theme: muiTheme, children }) });
};
const SunbeamThemeProvider = AscendThemeProvider;
export {
  AscendThemeProvider,
  SunbeamThemeProvider
};
//# sourceMappingURL=AscendThemeProvider.js.map
